import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import PersonalPricePlanBlockData from 'app/Models/Content/PersonalPricePlanBlockData';
import PersonalPricePlanBlockMain from './PersonalPricePlanBlockMain';

export default class PersonalPricePlanBlock extends EpiComponent<PersonalPricePlanBlockData> {

    public render(): ReactNode | ReactNodeArray | null {
        return (
         <PersonalPricePlanBlockMain iContent={this.props.data} context={this.getContext()} />
        );
    }
}
